import { render, staticRenderFns } from "./Pix.vue?vue&type=template&id=31d9f089&scoped=true"
import script from "./Pix.vue?vue&type=script&lang=ts"
export * from "./Pix.vue?vue&type=script&lang=ts"
import style0 from "./Pix.vue?vue&type=style&index=0&id=31d9f089&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d9f089",
  null
  
)

export default component.exports